<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowDownThick } from "@mdi/js";
export default {
  name: "MdiArrowDownThick",
  data() {
    return {
      svgPath: mdiArrowDownThick,
    };
  },
};
</script>
